function createEventString(event) {
    return [event.category, event.action, event.label, event.value].join('|').replace(/\|+$/, '');
}
export function formatEvent(event) {
    const eventString = typeof event === 'string' ? event : createEventString(event);
    return `event1=${eventString}`;
}
